var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcnNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3667_8303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8696 9.39138L12 15.1305L3.13049 9.39138V0.521826C3.12438 0.239795 3.34806 0.00623652 3.63009 0.000122415C3.63747 -2.4323e-05 3.64486 -2.4323e-05 3.65225 0.000122415H20.3478C20.6298 -0.00599169 20.8634 0.217687 20.8696 0.499718C20.8697 0.507104 20.8697 0.51449 20.8696 0.521875V9.39138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13048 9.39121L6.10352e-05 7.30425L3.13048 4.17383V9.39121Z",
    fill: "#F6B445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 7.30425L20.8695 9.39121V4.17383L23.9999 7.30425Z",
    fill: "#F6B445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8696 9.34469L24 7.30469V21.9133C23.999 22.4667 23.7796 22.9973 23.3895 23.3899L19.8261 19.8264L14.087 14.0873L13.9409 13.8629L20.8696 9.34469Z",
    fill: "#FED049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8261 19.8262L23.3896 23.3897C22.997 23.7798 22.4664 23.9991 21.913 24.0001H2.08707C1.53367 23.9991 1.00306 23.7798 0.610535 23.3897L4.17398 19.8262L9.91307 14.0872L10.0592 13.8628L12 15.1306L13.9409 13.8628L14.087 14.0872L19.8261 19.8262Z",
    fill: "#F6B445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0592 13.8629L9.91308 14.0873L4.174 19.8264L0.610554 23.3898C0.220474 22.9973 0.00110033 22.4667 0.00012207 21.9133V7.30469L10.0592 13.8629Z",
    fill: "#FED049"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3667_8303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcnNew);
export default __webpack_public_path__ + "static/media/mail-icn-new.aef654893856f3a6b34d3770ca580a5f.svg";
export { ForwardRef as ReactComponent };